import React from "react";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import {BreadcrumbItem, Breadcrumb, Col} from 'react-bootstrap';
import { Link } from 'react-router-dom';
const Compliance = () =>{
    const handleLinkClick = () => {
        // Scroll to the top of the page
        window.scrollTo(0, 0);
      };
return (
<div className="RightsandResponsibilities">
    <section className="inner-banner banner-align">
        <img className="img-fluid" src="./assets/img/innerbanner/policies.jpg" alt="" />
    </section>
    <section className="research-box-area">
        <Container>
            <Breadcrumb>
                <BreadcrumbItem>
                    <Link as={Link} to="/">
                    Home
                    </Link>
                </BreadcrumbItem>
                <BreadcrumbItem>
                    <Link as={Link} to="/About">
                    About
                    </Link>
                </BreadcrumbItem>
                <BreadcrumbItem active>Patron / User Policies</BreadcrumbItem>
            </Breadcrumb>
            <div className='information-content'>
                <h2>Patron / User Policies</h2>
            </div>
            <Row>
                <Col lg={5} sm={6}>
                <div className="floating-Side-wrap">
                    <div className="floating-Side">
                        <div className="right-tab-collab">
                            <div className="flex-column nav nav-pills">
                            <div className="nav-item">
                                    <Link as={Link} to="/BorrowingPolicies" 
                                    onClick={handleLinkClick} className='nav-link'>
                                    Borrowing Policies
                                    </Link>
                                </div>
                                <div className="nav-item">
                                    <Link as={Link} to="/ComputerUsePolicy" 
                                    onClick={handleLinkClick} className='nav-link'>
                                    Computer Use Policy
                                    </Link>
                                </div>
                                <div className="nav-item">
                                    <Link as={Link} to="/DiscussionRoomsPolicy" 
                                    onClick={handleLinkClick} className='nav-link' >
                                    Discussion Rooms Policy
                                    </Link>
                                </div>
                                <div className="nav-item">
                                    <Link as={Link} to="/LibrarySpaces" 
                                    onClick={handleLinkClick} className='nav-link'>
                                    Library Spaces
                                    </Link>
                                </div>
                                <div className="nav-item">
                                    <Link as={Link} to="/compliance" 
                                    onClick={handleLinkClick} className='nav-link active'>
                                    Compliance
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                </Col>
                <Col lg={7} sm={6}>
                    <div className="policyBox second">
                        <h5>Compliance</h5>
                        <p>To ensure that the HU library is always used as a conducive, research, learning, reflective, and collaborative space, there are norms and etiquettes defined for each zone in the library. Click here to explore the norms of each space. </p>
                        <p>In case of continuous non-compliance with the norms, the cases would be forwarded to the conduct office.</p>
                    </div>
                </Col>
            </Row>
        </Container>
    </section>
</div>
);
}
export default Compliance;